import React, { forwardRef, useEffect, useState } from 'react';

import { Input } from '@vlabs/uikit/components/controls/input';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import st from './popovers.module.sass';
import { useUserFiltersTranslation } from '../i18n';
import { useUserListFilters } from '../useUserListPageFilters';

function UserIdFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useUserFiltersTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters, updateFiltersDebounced } = useUserListFilters();

  const onChangeHandler = (userId: string) => {
    setLocalValue(userId);
    updateFiltersDebounced({ user_ids: [userId] });
  };

  useEffect(() => {
    setLocalValue(filters?.user_ids?.length ? filters?.user_ids[0] as string : '');
  }, [filters.user_ids]);

  const reset = () => {
    updateFilters({ user_ids: undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      data-testid="user_ids"
      onClickReset={reset}
      ref={ref}
      title={<div className={st.PopoverTitle}>{t('user_id.label')}</div>}
    >
      <Input
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const UserIdFilterPopoverWithRef = forwardRef(UserIdFilterPopover);
export { UserIdFilterPopoverWithRef as UserIdFilterPopover };
